export default {
  header: 'Avgiftsinformasjon',
  amountPaid: 'Betalt beløp',
  datePaid: 'Betalingsdato',
  notPaid: 'Ikke betalt',
  paymentReferenceId: 'Betalingsreferanse-ID',
  na: 'I/T',
};
